module.exports = __webpack_public_path__ + "static/media/media-7.da02edc3.jpg";